export default __webpack_public_path__ + "static/media/twitter.4641f134.svg";